import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NaturezaFinanceiraService } from '@app/modules/natureza_financeira/services/natureza_financeira.service';
import { SELECT } from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { filter } from 'rxjs/operators';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';

@Component({
  selector: 'app-fast-natureza-financeira',
  templateUrl: './fast-natureza-financeira.component.html',
  styleUrls: ['./fast-natureza-financeira.component.scss'],
  providers: [NaturezaFinanceiraService]
})
export class FastNaturezaFinanceiraComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;

  tipoPortador = [
    { viewValue: 'Despesa', value: 'DESPESA' },
    { viewValue: 'Receita', value: 'RECEITA' }
  ] as SELECT[];

  constructor(
    protected fb: UntypedFormBuilder,
    protected entityService: NaturezaFinanceiraService,
    protected snackBar: MatSnackBar,
    protected dialogRef: MatDialogRef<FastNaturezaFinanceiraComponent>,
    protected tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          CustomValidators.isEmptyValue()
        ]
      ],
      periodicidade: [false, [Validators.required]],
      tipo: [this.tipoPortador[1], [Validators.required]],
      natureza_financeira: [
        null,
        [CustomValidators.typeIs('object'), CustomValidators.isEmptyValue()]
      ]
    });
  }

  onSubmit() {
    this.loading = true;
    var entity = {
      domain_id: this.tokenService.getDomain().id,
      ...this.form.value
    };
    entity = Utils.trimAttributes(entity);
    entity.tipo = this.form.value.tipo.value;
    delete entity.natureza_financeira;
    entity.natureza_financeira_id = this.form.value.natureza_financeira
      ? this.form.value.natureza_financeira.id
      : null;

    if (this.form.valid) {
      this.entityService
        .insert(entity)
        .pipe(filter(result => !!result))
        .subscribe(
          formPgmt => {
            this.loading = false;
            this.dialogRef.close(formPgmt);
            this.snackBar.open(
              'Natureza financeira cadastrada com sucesso.',
              'X',
              {
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['msg-success']
              }
            );
          },
          () => {
            this.loading = false;
            this.snackBar.open('Erro ao cadastrar natureza financeira.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }
}
